import SectionNavbar from './SectionNavbar';

const mainNav = [
  { route: '/map', value: '지도 정규식' },
  { route: '/ultimatum', value: '결전 정규식' },
  { route: '/voyage', value: '항해 정규식' },
  { route: '/trans', value: '정규식 변환기' },
  { route: '/savelist', value: '저장한 목록' },
  {
    route: '/scarabs',
    value: '시세',
    children: [
      { route: '/scarabs', value: '갑충석' },
      { route: '/beast', value: '야수' },
      { route: '/tattoo', value: '문신' },
      { route: '/rune', value: '룬' },
      { route: '/oil', value: '성유' },
    ],
  },
  { route: '/ddalggak', value: '딸깍 시뮬' },
  { route: '/dust', value: '마석학 가루' },
  { route: '/challenges', value: '도전과제' },
  { route: '/siosa', value: '시오사' },
];

const utilityNav = [
  { route: '/update', value: '변경사항' },
  { route: '/guide', value: '이용 가이드' },
  { route: '/bugreport', value: '버그 제보' },
];

function Poe1Navbar() {
  return <SectionNavbar mainNav={mainNav} utilityNav={utilityNav} />;
}

export default Poe1Navbar;
